import {
    CHECKOUT_URL_REGEX as SOURCE_CHECKOUT_URL_REGEX,
    CheckoutSteps as SourceCheckoutSteps,
    CheckoutStepUrl as SourceCheckoutStepUrl,
    CheckoutUrlSteps as SourceCheckoutUrlSteps,
    PAYMENT_TOTALS as SOURCE_PAYMENT_TOTALS,
    UPDATE_EMAIL_CHECK_FREQUENCY,
    UPDATE_SHIPPING_COST_ESTIMATES_FREQUENCY,
} from 'SourceRoute/Checkout/Checkout.config';

export {
    UPDATE_EMAIL_CHECK_FREQUENCY,
    UPDATE_SHIPPING_COST_ESTIMATES_FREQUENCY,
};

export const CHECKOUT_URL_REGEX = SOURCE_CHECKOUT_URL_REGEX;

export const PAYMENT_TOTALS = SOURCE_PAYMENT_TOTALS;

export const CheckoutSteps = { ...SourceCheckoutSteps };

export const CheckoutUrlSteps = { ...SourceCheckoutUrlSteps, SHIPPING_URL_STEP: '' };

export const CheckoutStepUrl = { ...SourceCheckoutStepUrl, SHIPPING_URL: '/checkout' };
